import axios from 'axios';
import { getCachedToken, updateToken } from './tokenManager';

// 请求地址
const API_BASE_URL = 'https://' + process.env.API_HOST;

// 创建 Axios 实例
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 100000,
});

// 设置请求拦截器
axiosInstance.interceptors.request.use(
  async (config) => {
    if (config.url.includes('/api/openapi/oauth/token')) {
      // Token 获取接口无需拦截处理
      return config;
    }

    // 获取或更新 token
    let token = getCachedToken();
    if (!token) {
      token = await updateToken();
    }
    // 设置 Authorization header
    config.headers['Authorization'] = token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    // 正常响应直接返回
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // 防止死循环
      try {
        await updateToken(); // 请求新的 Token
        const newToken = getCachedToken();
        originalRequest.headers['Authorization'] = newToken; // 设置新 Token
        return axiosInstance(originalRequest); // 重试当前请求
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

// 通用 POST 方法封装
export const post = (url, params) => {
  return axiosInstance
    .post(url, params)
    .then((res) => ({
      code: res.data.code,
      data: res.data.data,
      msg: res.data.msg,
    }))
    .catch((err) => {
      return {
        code: err.response?.status || 400,
        data: null,
        msg: err.response?.data?.msg || '请求错误',
      };
    });
};

// 通用 GET 方法封装
export const get = (url, params) => {
  return axiosInstance
    .get(url, { params })
    .then((res) => ({
      code: res.data.code,
      data: res.data.data,
      msg: res.data.msg,
    }))
    .catch((err) => {
      return {
        code: err.response?.status || 400,
        data: null,
        msg: err.response?.data?.msg || '请求错误',
      };
    });
};

// 导出 Axios 实例
export default { get, post };
